<script lang="ts">
  import Object from "./Object.svelte";
</script>

<Object {...$$props}>
  <rect x="22" y="19" width="2" height="2" />
  <rect x="26" y="19" width="2" height="2" />
  <path
    d="M49,40.9A9,9,0,0,0,41,36H38V33a4.948,4.948,0,0,0-1.026-3H37V13A11.013,11.013,0,0,0,26,2H24A11.013,11.013,0,0,0,13,13V30h.026A4.948,4.948,0,0,0,12,33V49a3,3,0,0,0,3,3h1v1a9.01,9.01,0,0,0,9,9H44a9.01,9.01,0,0,0,9-9V50a3.959,3.959,0,0,0-.556-2H53a9.01,9.01,0,0,0,9-9V36H57A9,9,0,0,0,49,40.9ZM34,54V52h1a3,3,0,0,0,3-3V44.644A8.983,8.983,0,0,0,45,48h.556A3.959,3.959,0,0,0,45,50v3a1,1,0,0,1-1,1ZM18,42H32v4H18Zm8-5V34h5a1,1,0,0,1,1,1v5H18V35a1,1,0,0,1,1-1h5v3Zm8,9h2v3a1,1,0,0,1-1,1H34Zm14-1v1H45a7,7,0,0,1-6.993-6.859l4.353,3.628,1.28-1.538L39.762,38H41A7.008,7.008,0,0,1,48,45ZM15,13a9.01,9.01,0,0,1,9-9h2a9.01,9.01,0,0,1,9,9V28H33V16.077c.115-.775.664-5.745-3.511-8.877l-1.2,1.6a7.341,7.341,0,0,1,2.8,6.2H28.954A12.73,12.73,0,0,0,27.9,10.553l-1.79.894A10.521,10.521,0,0,1,26.948,15h-3.9a10.521,10.521,0,0,1,.843-3.553l-1.79-.894A12.73,12.73,0,0,0,21.046,15H18.9a7.175,7.175,0,0,1,2.7-6.2L20.4,7.2c-4.166,3.125-3.536,8.073-3.4,8.887V28H15ZM31,28H28V25.937a5.543,5.543,0,0,0,3-1.293ZM19,24.562a5.39,5.39,0,0,0,3,1.372V28H19ZM14,33a3,3,0,0,1,3-3h7V24H23c-3.306,0-4-2.719-4-5V17H31v2c0,4.432-2.138,5-4,5H26v6h7a3,3,0,0,1,3,3V44H34V35a3,3,0,0,0-3-3H19a3,3,0,0,0-3,3v9H14Zm1,17a1,1,0,0,1-1-1V46h2v4Zm36,3a7.008,7.008,0,0,1-7,7H35V58H33v2H25a7.008,7.008,0,0,1-7-7V48H32v8h8v2h2V56h2a3,3,0,0,0,2.816-2H49V52H47V50a2,2,0,0,1,4,0Zm2-7H50V45a7.008,7.008,0,0,1,7-7h1.238L54.36,41.231l1.28,1.538,4.353-3.628A7,7,0,0,1,53,46Z"
  />
  <rect x="20" y="50" width="2" height="2" />
  <rect x="24" y="53" width="2" height="2" />
  <rect x="28" y="50" width="2" height="2" />
  <rect x="28" y="56" width="2" height="2" />
  <rect x="4" y="17" width="2" height="2" />
  <rect x="4" y="21" width="2" height="2" />
  <rect x="2" y="19" width="2" height="2" />
  <rect x="6" y="19" width="2" height="2" />
  <rect x="45" y="21" width="2" height="2" />
  <rect x="45" y="25" width="2" height="2" />
  <rect x="43" y="23" width="2" height="2" />
  <rect x="47" y="23" width="2" height="2" />
  <rect x="5" y="34" width="2" height="2" />
  <rect x="5" y="38" width="2" height="2" />
  <rect x="3" y="36" width="2" height="2" />
  <rect x="7" y="36" width="2" height="2" />
  <rect x="43" y="2" width="2" height="2" />
  <rect x="43" y="6" width="2" height="2" />
  <rect x="41" y="4" width="2" height="2" />
  <rect x="45" y="4" width="2" height="2" />
</Object>
